import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/utility/auth/auth.service';
import { AppComponent } from 'src/app/app.component';
import {
  CloudAccountRegisterComponent,
  CloudAccountListMappingComponent,
  CloudAccountMappingRegisterComponent

} from '@serengeti/serengeti-cloud-account';
import { ConsoleCloudAccountListComponent } from '../app/cloud-account/list/list.component';

const routes: Routes = [
	{ path: 'main', component: AppComponent, canActivate: [AuthService], children: [
		{ path: 'cloud/account/mapping/list', component: CloudAccountListMappingComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'account.title',  root: true }},
		{ path: 'cloud/account/mapping/register', component: CloudAccountMappingRegisterComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'account.title',  root: true }},
    { path: 'cloud/account/list', component: ConsoleCloudAccountListComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'account.title',  root: true }},
    { path: 'cloud/account/register', component: CloudAccountRegisterComponent, outlet: 'content', canActivate: [AuthService], data: { title: 'account.title',  root: true }},
	]}
];

@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
		CommonModule
	]
})
export class AppRoutingCloudAccountModule { }
